export default __webpack_public_path__ + "static/media/image13.a5e6c1d7.jpg";